import {useTranslation} from "react-i18next";
import * as yup from "yup";
import React, {useContext, useEffect, useState} from "react";
import {useForm} from "common/src/hooks/form/formHook";
import {saveServiceAccount} from "../../../../state/api/serviceAccountAPI";
import {useDispatch} from "react-redux";
import FormContainer from "common/src/components/form/FormContainer";
import Input from "common/src/components/widget/Input";
import Checkbox from "common/src/components/widget/Checkbox";
import Button from "common/src/components/widget/Button";
import PropTypes from "prop-types";
import {addErrorNotification, addSuccessNotification} from "../../../../state/notification/notifications";
import {hasRole} from "../../../../utils/userUtils";
import {Role} from "../../../../auth/roles";
import {UserContext} from "../../../../context/UserContext";

const GroupServiceAccountFormModal = ({serviceAccount = {}, group, ...props}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [busy, setBusy] = useState(false);
    const {user} = useContext(UserContext);

    const schema = {
        name: yup.string().min((1 + (group?.name?.length ?? 0)), t('name_required')).required().max(255, t('length_exceeded_error')).required(),
        groupId: yup.string().required()
    };

    const {
        values,
        getField,
        setFormNotDirty,
        handleSubmit,
        setValues,
        isEdited
    } = useForm(submit, {...serviceAccount, groupId: group.id}, schema);

    useEffect(() => {
        if (serviceAccount && group) {
            setValues({...serviceAccount, groupId: group?.id});
            setFormNotDirty();
        }
        return () => {
            props.onClose();
        }
    }, [serviceAccount, group]);

    async function submit() {
        if (!hasRole(user, Role.ADMIN_GROUPS)) {
            dispatch(addErrorNotification(
                {title: t(`toast.error`), content: t(`toast.insufficient_permissions`)})
            );
            return;
        }
        setBusy(true);
        const requestData = {
            id: values?.id,
            name: values.name,
            isActive: values.isActive,
            groupId: values.groupId
        }
        const errorMessage = serviceAccount.id ? t('toast.error_edit_service_account') : t('toast.error_add_service_account');
        const successMessage = serviceAccount.id ? t('toast.success_edit_service_account') : t('toast.success_add_service_account');

        await dispatch(saveServiceAccount(requestData)).unwrap()
            .then((value) => {
                setBusy(false);
                dispatch(addSuccessNotification({
                    title: t('toast.success'),
                    content: t(successMessage)
                }))
                if (props.onSave) {

                    props.onSave(!!value ? value : requestData);
                }  else if (props.onClose) {
                    props.onClose();
                }
            }).catch(() => {
                setBusy(false);
                dispatch(addErrorNotification({
                    title: t('toast.error'),
                    content: t(errorMessage)
                }));
            }).finally(() => {
                setBusy(false);
            });
    }

    return (
        <>
            <FormContainer onSubmit={handleSubmit} isEdited={isEdited}>
                <Input
                    label={t('service_account.name')}
                    name="username"
                    prefix={group.name + "-"}
                    formField={getField('name')}
                    disabled={!!getField('id').value}
                />

                {serviceAccount.groupId && group && <Input
                    label={t('service_account.group.name')}
                    name="service_account_group_name"
                    value={group.name}
                    disabled={true}
                />}
                <Checkbox
                    label={t('service_account.is_active')}
                    name="service_account_active"
                    formField={getField('isActive')}
                />

                <div className={'modal-card-foot'}>
                    <Button
                        isSubmit={true}
                        isLoading={busy}
                        color="primary"
                        label={t('service_account.save')}
                    />
                    <Button
                        color="primary"
                        label={t('service_account.cancel')}
                        isOutlined={true}
                        onClick={() => props.onClose ? props.onClose() : null} // Close the modal
                        isDisabled={busy}
                    />
                </div>
            </FormContainer>
        </>

    );
};

export default GroupServiceAccountFormModal;

GroupServiceAccountFormModal.propTypes = {
    serviceAccount: PropTypes.object,
    group: PropTypes.object,
    onSave: PropTypes.func,
    onClose: PropTypes.func
}

